import { Grid, GridItem } from '@chakra-ui/react';
import React from 'react';

interface LabelVersionDetailsFormGridProps {
  altTitle: React.ReactNode;
  artist: React.ReactNode;
  genres: React.ReactNode;
  keySignature: React.ReactNode;
  timeSignature: React.ReactNode;
  tempo: React.ReactNode;
  duration: React.ReactNode;
  language: React.ReactNode;
  explicit: React.ReactNode;
  location: React.ReactNode;
}

export const LabelVersionDetailsFormGrid = ({
  artist,
  altTitle,
  genres,
  explicit,
  tempo,
  language,
  keySignature,
  timeSignature,
  duration,
  location,
}: LabelVersionDetailsFormGridProps) => {
  return (
    <Grid templateColumns="repeat(4, 1fr)" gap={4}>
      <GridItem colSpan={{ base: 4, md: 2 }}>{altTitle}</GridItem>
      <GridItem colSpan={{ base: 4, md: 2 }}>{artist}</GridItem>
      <GridItem colSpan={{ base: 4, md: 2 }}>{genres}</GridItem>
      <GridItem colSpan={{ base: 4, md: 2 }}>{keySignature}</GridItem>
      <GridItem colSpan={{ base: 4, md: 2 }}>{timeSignature}</GridItem>
      <GridItem colSpan={{ base: 4, md: 2 }}>{tempo}</GridItem>
      <GridItem colSpan={{ base: 4, md: 2 }}>{duration}</GridItem>
      <GridItem colSpan={{ base: 4, md: 2 }}>{language}</GridItem>
      <GridItem colSpan={{ base: 4, md: 2 }}>{explicit}</GridItem>
      <GridItem colSpan={{ base: 4, md: 2 }} minH="144px">
        {location}
      </GridItem>
    </Grid>
  );
};
